import styled from 'styled-components';
import { COLORS, BREAKPOINTS, SPACING } from '../style';

type ContainerColor = 'white' | 'lightgrey';

const StyledContainer = styled.div<{ $color: ContainerColor }>`
  background: ${({ $color }) => COLORS[$color]};

  > div {
    max-width: ${BREAKPOINTS.notebook};
    margin: 0 auto;

    & > div {
      min-height: 80vh;
      scroll-margin-top: 20vh;

      @media (max-width: ${BREAKPOINTS.tablet}) {
        scroll-margin-top: 50px;
      }
    }

    @media (max-width: ${BREAKPOINTS.notebook}) and (min-width: ${BREAKPOINTS.tablet}) {
      max-width: ${BREAKPOINTS.tablet};
    }

    @media (max-width: ${BREAKPOINTS.tablet}) {
      max-width: 100vw;
      padding: 0 ${SPACING.md};
    }

    @media (max-width: ${BREAKPOINTS.mobile}) {
      padding: 0 ${SPACING.sm};
    }
  }
`;

interface ContainerProps {
  children: React.ReactNode;
  color: ContainerColor;
}

const Container = ({ children, color }: ContainerProps) => {
  return <StyledContainer $color={color}>{children}</StyledContainer>;
};

export default Container;